import get from 'lodash/get';

// online order errors
const ERROR_INVALID_ORDER =
  "We're sorry. We couldn't find that order and email combination. Please try re-entering your order number and email. You can find your order number in your order confirmation email.";
const ERROR_TECHNICAL =
  "We're sorry. There was a temporary technical error with displaying your order details. Please try again shortly.";
const ERROR_PROCESSING =
  "We're sorry. We are still processing your order. Please try again in approximately 5 minutes.";

// instore order errors
const ERROR_INVALID_INSTORE =
  "We're sorry. We couldn't find that order and phone number combination. Please try re-entering your order number and phone number.";
const ERROR_TECHNICAL_INSTORE =
  "We're sorry. There was a temporary technical issue with displaying your In-Store order details. Please try again shortly.";

// const error_instore_phone_empty_msg =
//   'A phone number is required. Please enter a valid phone number.';
// const error_instore_invalid_phone_msg =
//   'Phone number is invalid. Please enter a valid phone number.';
// const error_email_empty_msg =
//   'An email address is required. Please enter a valid email address.';
// const error_invalid_email_msg =
//   'Please provide your email, formatted as you@domain.com';
// const error_order_empty_msg =
//   'An order number is required. Please enter your order number.';
// const error_instore_order_empty_msg =
//   'An order number is required. Please enter your order number.';
// const order_number_provide = 'Please provide your order number.';
// const order_number_provide_2 =
//   'For online orders, this starts with either the letter W or C.';
// const order_number_provide_3 =
//   'For in-store orders, this starts with the letter H.';
// const case2_online_error =
//   'Please provide your complete order number. For online orders, you can find your order number in your confirmation email.';
// const case3_instore_error = 'Please provide your complete order number.';
// const email_error_message =
//   'Please provide your email, formatted as you@domain.com.';
// const valid_tendigit_phone = 'Please provide your 10 digit phone number.';

export const handleOnlineOrderError = (errorCode: string) => {
  if (errorCode === null) return null;
  switch (errorCode) {
    case 'OS_COMORDERDETAILS_ERR_2001':
    case 'OS_COMORDERDETAILS_ERR_2002':
    case 'OS_COMORDERDETAILS_ERR_2003':
    case 'OS_COMORDERDETAILS_ERR_2006':
    case 'OS_COMORDERDETAILS_ERR_2011':
      return ERROR_INVALID_ORDER;
    case 'OS_COMORDERDETAILS_ERR_2010':
      return ERROR_PROCESSING;
    default:
      return ERROR_TECHNICAL;
  }
};

export const handleInStoreOrderError = (errorCode: string) => {
  if (errorCode === null) return null;
  switch (errorCode) {
    case 'OS_INSTORE_ORDER_DETAILS_ERR_2505':
    case 'OS_INSTORE_ORDER_DETAILS_ERR_2509':
    case 'OS_INSTORE_ORDER_DETAILS_ERR_2510':
      return ERROR_INVALID_INSTORE;
    default:
      return ERROR_TECHNICAL_INSTORE;
  }
};

export const handleTechnicalError = (errorCode: string) => {
  if (errorCode === null) return false;
  switch (errorCode) {
    case 'OS_COMORDERDETAILS_ERR_2001':
    case 'OS_COMORDERDETAILS_ERR_2002':
    case 'OS_COMORDERDETAILS_ERR_2003':
    case 'OS_COMORDERDETAILS_ERR_2006':
    case 'OS_COMORDERDETAILS_ERR_2010':
    case 'OS_COMORDERDETAILS_ERR_2011':
    case 'OS_INSTORE_ORDER_DETAILS_ERR_2505':
    case 'OS_INSTORE_ORDER_DETAILS_ERR_2509':
    case 'OS_INSTORE_ORDER_DETAILS_ERR_2510':
      return false;
    default:
      return true;
  }
};

export const getErrorMessage = (response: Object) => {
  if (!response) return '';
  return get(response, 'data.errorData.errors.error[0].description', '');
};

export const getErrorCode = (response: Object) => {
  if (!response) return '';
  return get(response, 'data.errorData.errors.error[0].code', '');
};
